<template>
    <div class="wui-container phone_stop">
        <p>{{ $t("phone_stop.header") }}<span class="email">hello@wellcee.com</span></p>
        
        <div class="card">
            <div class="title">{{ $t("phone_stop.card.title") }}</div>

            <div class="list">
                <div class="item">{{ $t("phone_stop.card.item1") }}</div>
                <div class="item">{{ $t("phone_stop.card.item2") }}</div>
                <div class="item">{{ $t("phone_stop.card.item3") }}</div>
                <div class="item">{{ $t("phone_stop.card.item4") }}</div>
                <div class="item">{{ $t("phone_stop.card.item5") }}</div>
            </div>
        </div>
        <p>{{ $t("phone_stop.footer") }}</p>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { useRoute } from "vue-router";

export default {
    data() {
        return {
            
        };
    },
    mounted() {
        const route = useRoute();
        if (route.query.theme == 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
        }
        if (route.query.lang && ['zh', 'en', 'tw'].includes(route.query.lang)) {
            this.$i18n.locale = route.query.lang
        }
        document.title = this.$t('phone_stop.title');
    },
    methods: {
        
    },
};
</script>

<style scoped>
.phone_stop{
    box-sizing: border-box;
    min-height: 100vh;
    overflow: hidden;
    padding: 30px;
    background-color: var(--wlc-bg-white);
}
.phone_stop p {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    color: var(--wlc-text-color);
}
.phone_stop .email{
    color: var(--wlc-primary-color);
}
.phone_stop ul{
    margin: 20px 0;
}
.phone_stop ul li {
    list-style-type: decimal;
    list-style-position: inside;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    color: var(--wlc-text-color);
}
.phone_stop .card{
    padding: 15px;
    border-radius: 10px;
    background: var(--wlc-bg-color);
}
.phone_stop .card .title{
    font-size: 12px;
    font-weight: 600;
    line-height: 17px;
    margin-bottom: 20px;
    color: var(--wlc-text-gray-color);
}
.phone_stop .card .list .item{
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    margin-top: 6px;
    color: var(--wlc-text-gray-color);
}
</style>
